import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Flex, Text, xcss } from '@atlaskit/primitives';
import { IconButton } from '@atlaskit/button/new';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import Tooltip from '@atlaskit/tooltip';

const i18n = defineMessages({
	back: {
		id: 'content-history-new.header.back.button.tooltip',
		defaultMessage: 'Back to content',
		description: 'The message displayed in the back button tooltip to go back to original content',
	},
	current: {
		id: 'content-history-new.header.back.button.current',
		defaultMessage: 'Current',
		description: 'The message displayed next to date and time if version is current one',
	},
});

const headerStyles = xcss({
	height: '56px',
	width: '100%',
	borderBottom: '1px solid',
	borderColor: 'color.border',
});

const buttonWrapperStyles = xcss({
	marginLeft: 'space.150',
});

type ContentHistoryHeaderProps = {
	hideNewContentHistory: () => void;
};

export const ContentHistoryHeader = ({ hideNewContentHistory }: ContentHistoryHeaderProps) => {
	const { formatMessage } = useIntl();

	const handleClick = () => {
		hideNewContentHistory();
	};

	return (
		<Flex xcss={headerStyles} alignItems="center" gap="space.200">
			<Flex xcss={buttonWrapperStyles}>
				<Tooltip content={formatMessage(i18n.back)} position="bottom">
					{(tooltipProps) => (
						<IconButton
							{...tooltipProps}
							icon={ArrowLeftIcon}
							label=""
							onClick={handleClick}
							testId="content-history-back-button"
						/>
					)}
				</Tooltip>
			</Flex>
			<Flex alignItems="center" gap="space.050">
				<Text weight="bold"> April 17, 9:46 a.m. </Text>
				<Text> ({formatMessage(i18n.current)}) </Text>
			</Flex>
		</Flex>
	);
};
